/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-29 09:48:01
 * @Description: file content
 */ 
import React, { Component } from 'react';
import { Col as OriginCol } from 'bee-layout';
import {getSysFieldid} from '@platform/api';

require('bee-layout/build/Layout.css');

export default class Col extends Component {
    render() {
        let {
            fieldid,
            ...others
        } = this.props;
        fieldid = getSysFieldid(fieldid);
        return <OriginCol {...others} fieldid={fieldid} />;
    }
}
